import { countPixelEvent } from "@/api/CountPixelEventAPI";
import { submitTikTokConversionEvent } from "@/api/FacebookAPI";
import { generateEventId } from "@/utils/RandomGeneratorUtils";

const dispatchEvent = (eventName, eventKey, productId, tiktokEventName) => {
  const eventId = generateEventId(eventKey, productId);

  try {
    const request = countPixelEvent(eventName, eventId);
    request?.catch?.((error) => {
      console.warn(`Tracking event failed: ${eventName}`, error);
    });
  } catch (error) {
    console.warn(`Tracking event failed: ${eventName}`, error);
  }

  // TikTok 只接收阶段事件，不附带姓名、联系方式、证件地址等 KYC 数据。
  if (tiktokEventName) {
    submitTikTokConversionEvent(tiktokEventName);
  }
};

export const legacyTrackingAdapter = {
  personalInfoCompleted() {
    dispatchEvent("Info Done", "personal_info_complete", undefined, "InfoDone");
  },
  documentCompleted() {
    dispatchEvent(
      "Documents",
      "document_upload_complete",
      undefined,
      "Documents",
    );
  },
  proofCompleted() {
    dispatchEvent(
      "Proof Done",
      "proof_upload_complete",
      undefined,
      "ProofDone",
    );
  },
  submissionStarted() {
    dispatchEvent(
      "Initiate Checkout",
      "InitiateCheckout",
      "job",
      "InitiateCheckout",
    );
  },
};
